module.exports = __webpack_public_path__ + "static/media/Loyalty.4ddf38fe.svg";